/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Banner_AddInputs */



/**
* | output |
* | --- |
* | "Add banner" |
*
* @param {Tournament_Banner_AddInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_banner_add = /** @type {((inputs?: Tournament_Banner_AddInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Banner_AddInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter une bannière")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir banner")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar banner")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi banner")
	return /** @type {LocalizedString} */ ("Add banner")
});